import { ReactNode, createContext } from "react";
import useProduto, { ProdutoType, CreateProdutoType, UpdateProdutoType } from "./hooks/useProduto";

interface ProdutoContextProviderProps {
    children: ReactNode;
}

export interface ProdutoContextData {
    getAllProdutoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<ProdutoType[] | null>;
    setProduto: any;
    produto: ProdutoType;
    setListProduto: any;
    listProduto: ProdutoType[];
    setInitialListProduto: any;
    initialListProduto: ProdutoType[];
    setProdutoPageCount: any;
    produtoPageCount: number;
    createProduto: (createProdutoType: CreateProdutoType) => Promise<CreateProdutoType | null>;
    updateProduto: (updateProdutoType: UpdateProdutoType) => Promise<UpdateProdutoType | null>;
    deleteProduto: (id: number) => Promise<ProdutoType | null>;
    handleGetProdutoByEmpresaId: (empresaId: number) => Promise<ProdutoType[] | null>;
    listProdutoByEmpresa: ProdutoType[];
    setListProdutoByEmpresa: any;
}

const initialState: ProdutoContextData = {
    getAllProdutoPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setProduto: () => { },
    produto: {
        id: 0,
        name: "",
        description: "",
        value: 0,
    },
    setListProduto: () => { },
    listProduto: [],
    setInitialListProduto: () => { },
    initialListProduto: [],
    setProdutoPageCount: () => { },
    produtoPageCount: 0,
    createProduto: async (createProdutoType: CreateProdutoType) => {
        return Promise.resolve(null);
    },
    updateProduto: async (updateProdutoType: UpdateProdutoType) => {
        return Promise.resolve(null);
    },
    deleteProduto: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetProdutoByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listProdutoByEmpresa: [],
    setListProdutoByEmpresa: () => { },
};

export const ProdutoContext =
    createContext<ProdutoContextData>(initialState);

export default function ProdutoContextProvider({
    children,
}: ProdutoContextProviderProps) {
    const {
        getAllProdutoPaged,
        createProduto,
        updateProduto,
        deleteProduto,
        produto,
        setProduto,
        setListProduto,
        listProduto,
        initialListProduto,
        setInitialListProduto,
        setProdutoPageCount,
        produtoPageCount,
        handleGetProdutoByEmpresaId,
        listProdutoByEmpresa,
        setListProdutoByEmpresa,
    } = useProduto();

    return (
        <ProdutoContext.Provider
            value={{
                getAllProdutoPaged,
                createProduto,
                updateProduto,
                deleteProduto,
                produto,
                setProduto,
                setListProduto,
                listProduto,
                initialListProduto,
                setInitialListProduto,
                setProdutoPageCount,
                produtoPageCount,
                handleGetProdutoByEmpresaId,
                listProdutoByEmpresa,
                setListProdutoByEmpresa,
            }}
        >
            {children}
        </ProdutoContext.Provider>
    );
}